module.exports = __webpack_public_path__ + "static/img/ikonaStepbystep-ON.a1ef5524.png";